import { render, staticRenderFns } from "./q-bank-update-page.html?vue&type=template&id=7bf7b917&scoped=true&external"
import script from "./q-bank-update-page.js?vue&type=script&lang=js&external"
export * from "./q-bank-update-page.js?vue&type=script&lang=js&external"
import style0 from "./q-bank-update-page.scss?vue&type=style&index=0&id=7bf7b917&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf7b917",
  null
  
)

export default component.exports